const CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE = 'Cross-workspace move and stitch are not supported.';

export const CROSS_WORKSPACE_DROP_TEXT = {
  fileNote: CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE,
  folderNote: `Copying a folder across workspaces is not supported yet. ${CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE}`,
  /**
   * The panel-3 gates (folder-form, file-form) compare tenants for every drag type, not only
   * file/folder — the rail restricts its honest dialog to those two via `ownsCrossWorkspaceDialog`
   * (side-bar.component.ts). A task/note/event/etc. dropped cross-workspace must not be told
   * "Copying a file..."; this is the type-neutral line for everything that is not a file or folder.
   */
  itemNote: `Copying items across workspaces is not supported yet. ${CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE}`,
  fileCopyTooltip: 'Cross-workspace file copy is not supported yet.',
  folderCopyTooltip: 'Cross-workspace folder copy is not supported yet.',
  moveTooltip: 'Cross-workspace move is not supported.',
  stitchTooltip: 'Cross-workspace stitching is not supported.',
} as const;
